<template>
  <div class="card">
    <div class="card-body" data-v-step="vendorLogos">
      <h3 v-if="!disabled">
        Upload Logo<i
          class="fas fa-sm fa-info-circle ml-2 cursor-pointer"
          v-tooltip.top="
            'It\'s recommended to use a square image of 1:1 aspect ratio, such as 200px X 200px'
          "
        ></i>
      </h3>
      <div class="form-group">
        <div class="row">
          <div class="col-md-12" v-if="!disabled">
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                @change="onFileSelected"
                accept="image/*"
              />
              <label class="custom-file-label">Choose file</label>
            </div>
            <div class="py-4" v-if="fileName">
              <div class="badge badge-primary">{{ fileName }}</div>
            </div>
            <div class="my-1" v-if="vendors.upload.uploading">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="`width: ` + vendors.upload.progress + `%`"
                >
                  {{ progressPercent }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="text-center pt-4">
              <img
                :src="profileImage"
                alt=""
                class="rounded-circle"
                style="height: 170px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "UploadLogo",
  props: ["vendorId", "disabled"],
  data: function () {
    return {
      waitingResponse: false,
    };
  },
  computed: {
    ...mapState(["vendors"]),
    selectedFile: function () {
      return this.vendors.upload.file;
    },
    fileName: function () {
      if (this.selectedFile) {
        return this.selectedFile.name;
      }
      return false;
    },
    profileImage: function () {
      if (this.vendors.upload.uploading || this.waitingResponse) {
        return `/images/pending-upload.png`;
      }

      if (!this.vendors.single.logo) {
        return "/images/no-logo.png";
      }

      return this.vendors.single.logoUrl;
    },
    progressPercent: function () {
      if (typeof this.vendors.upload.progress === "number") {
        if (this.vendors.upload.progress < 100) {
          return this.vendors.upload.progress + "%";
        } else {
          return "Processing Image.... ";
        }
      }
      return this.vendors.upload.progress;
    },
  },
  methods: {
    isImage: function (file) {
      if (file) {
        return file["type"].split("/")[0] === "image";
      }
    },
    getVender: function (id) {
      return this.$store.dispatch("vendors/getWithoutLoading", id);
    },
    onFileSelected: function (event) {
      var file = event.target.files[0];
      if (this.isImage(file)) {
        this.waitingResponse = true;
        this.$store
          .dispatch("vendors/uploadProfileImage", {
            vendor: this.vendors.single,
            file: file,
          })
          .then((success) => {
            if (success) {
              this.getVender(this.vendorId).then(() => {
                this.waitingResponse = false;
              });
            }
          });
      }
    },
  },
};
</script>
